import React from 'react';

const EmptyState = ({ 
  icon = '📭',
  title,
  description,
  action,
  actionText,
  size = 'md'
}) => {
  const iconSizes = {
    sm: 'text-2xl',
    md: 'text-4xl',
    lg: 'text-6xl'
  };

  const titleSizes = {
    sm: 'text-base',
    md: 'text-lg',
    lg: 'text-xl'
  };

  return (
    <div className="p-8 text-center">
      <div className={`${iconSizes[size]} mb-2`}>{icon}</div>
      <h3 className={`${titleSizes[size]} font-medium text-gray-900 mb-2`}>
        {title}
      </h3>
      {description && (
        <p className="text-gray-500 mb-4">{description}</p>
      )}
      {action && actionText && (
        <button
          onClick={action}
          className="clara-btn-primary px-4 py-2"
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
